import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  text: {
    fontSize: "1rem",
    wordWrap: "break-word",
    textAlign: "center",
    "& a": {
      color: theme.palette.primary.main,
    },
  },
}));

const ReferenceLink = ({ link, description }) => {
  const classes = useStyles();

  return (
    <>
      <p className={classes.text}>
        <a href={link} target="_blank" rel="noreferrer">
          {link}
        </a>
        &nbsp; {description}
      </p>
      <br />
    </>
  );
};

export default ReferenceLink;
